'use strict';

import template from './resetPasswordForm.component.html';
import { resetPasswordVerificationState } from '../resetPassword.states';

export const ResetPasswordFormComponent = {
	bindings: {},
	controller: ResetPasswordFormComponentCtrl,
	controllerAs: 'vm',
	template: template,
};

ResetPasswordFormComponentCtrl.$inject = ['$state', 'mx.sb.ResetPasswordService', 'mx.internationalization'];

export function ResetPasswordFormComponentCtrl($state, resetPasswordService, i18n) {
	const vm = this;

	vm.resetPassword = async function (email) {
		vm.submitted = true;
		vm.errorMsg = '';
		try {
			await resetPasswordService.resetPassword(email);
			$state.go(resetPasswordVerificationState.name, { email }, { reload: false });
		} catch (e) {
			vm.errorMsg = i18n.get(e?.data?.Message) || e?.data?.Message;
			vm.submitted = false;
		}
	};
}
